import styled from "styled-components"

export const GridStyled = styled.div`
  padding: 0.5rem;
  font-family: MontserratRegular;
`

export const RowsSearchPanel = styled.div`
  width: 100%;
  text-align: right;
  font-size: 1.2rem;
  padding: 1rem 1rem;
`

export const InputSearch = styled.input`
    width: 12rem;
    height: 2rem;
    background: #9C94941A 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 23px;
    opacity: 1;
    padding: 0.2rem 0.7rem;
`

export const TablePanel = styled.div`
  display: block;
  position: relative;
  height: 100%;
  padding: 0 0.5rem;
`

export const TableContainer = styled.div`
  display: block;
  position: relative;
  width: 100%;
  overflow-x: auto;
  
  table {
    width: 100%;
    display: table;
    font-size: 1rem;
    position: relative;
    max-height: 500px;
    
    // tbody {
    //   display: block;
    //   max-height: 250px;
    //   overflow-y: scroll;
    // }
    
    // thead, tbody tr {
    //   display: table;
    //   width: 100%;
    //   table-layout: fixed;
    // }
    
    // thead {
    //   // display: block;
    //   max-height: 100px;
    //   overflow-y: scroll;
    // }
    
    tr {
      font-size: 0.9rem;
      
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
        
    th {
      font-size: 1rem;
      border: 2px solid #9C949480;
      text-align: center;
      vertical-align: middle;
      padding: 0.2rem;
      height: 0.8rem;

      :last-child {
        align-items: center;
      }
    }

    td {
      font-size: 0.8rem;
      border: 2px solid #9C949480;
      text-align: center;
      vertical-align: middle;
      padding: 0.2rem;
      height: 2rem;

      :last-child {
        align-items: center;
      }
    }

    .cellNoBorder {
      border: 0;
      width: 4rem;
      
    }

    .content-button {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    .content-check {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
  }
`

interface PaginationPanel {
  bg?: string
}

export const PaginationPanel = styled.div`
  width: 100%;
  height: fit-content;
  border: 2px solid #9C949480;
  font-size: 1rem;
  margin-bottom: 1rem;
  padding: 0;

  button { 
    cursor: pointer;
    width: 25%;
    height: 2rem;
    display: block;
    background-color: gray;
    border: none;
    color: #FFFFFFE6;
  }

  .pagesCount {
    width: 50%;
    height: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`

interface TableButton {
  color?: string
  visible?: boolean
}

export const TableButton = styled.a`
  background-color: ${(p: TableButton) => p.color};
  border: 0;
  color: white;
  width: 100%;
  height: 1rem;
  display: ${(p: TableButton) => (p.visible) ? "flex" : "none"};
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &:hover {
    background: transparent;
    border: 2px solid ${(p: TableButton) => p.color};
    cursor: pointer;
    color: ${(p: TableButton) => p.color};
  }
`

interface TableCheck {
  color?: string
}

export const TableCheck = styled.input.attrs({ type: 'checkbox' })`
  display: inline-block;
  border: 2px #9C949480 solid;
  width: 100%;
  height: 1.2rem;

  &input:checked {
    background-color: ${(p: TableCheck) => "p.color"};
  }
`